<template>
  <div class="callback-form">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="section-heading">
            <h2>Request a <em>call back</em></h2>
            <span>Schedule your consultation with a quick email callback request.</span>
          </div>
        </div>
        <div class="col-md-12">
          <div class="contact-form">
            <form id="contact" ref="form" @submit.prevent="submitForm">
              <div class="row">
                <div class="col-lg-4 col-md-12 col-sm-12">
                  <fieldset>
                    <input
                      name="name"
                      type="text"
                      class="form-control"
                      id="name"
                      placeholder="Full Name"
                      required
                    />
                  </fieldset>
                </div>
                <div class="col-lg-4 col-md-12 col-sm-12">
                  <fieldset>
                    <input
                      name="email"
                      type="email"
                      class="form-control"
                      id="email"
                      placeholder="E-Mail Address"
                      required
                    />
                  </fieldset>
                </div>
                <div class="col-lg-4 col-md-12 col-sm-12">
                  <fieldset>
                    <input
                      name="subject"
                      type="text"
                      class="form-control"
                      id="subject"
                      placeholder="Subject"
                      required
                    />
                  </fieldset>
                </div>
                <div class="col-lg-12">
                  <fieldset>
                    <textarea
                      name="message"
                      rows="6"
                      class="form-control"
                      id="message"
                      placeholder="Your Message"
                      required
                    ></textarea>
                  </fieldset>
                </div>
                <div class="col-lg-12">
                  <fieldset>
                    <button
                      type="submit"
                      id="form-submit"
                      class="border-button"
                    >
                      Send Message
                    </button>
                  </fieldset>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showMessage"
      class="alert"
      :class="{ 'alert-primary]': !formError, 'alert-danger': formError }"
    >
      {{ resultMessage }}
    </div>
  </div>
</template>

<script>
import formMixin from '../mixins/fromMixin';
export default {
  name: "CallbackRequestCard",
  mixins: [formMixin],
};
</script>

<style scoped>
.alert {
  margin-top: 20px;
  padding: 10px;
  border-radius: 4px;
}
.alert-success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}
.alert-danger {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}
</style>
